import { render, staticRenderFns } from "./Newproducts.vue?vue&type=template&id=26b7d2f1&scoped=true&"
import script from "./Newproducts.vue?vue&type=script&lang=js&"
export * from "./Newproducts.vue?vue&type=script&lang=js&"
import style0 from "./Newproducts.vue?vue&type=style&index=0&id=26b7d2f1&scoped=true&lang=css&"
import style1 from "./Newproducts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7d2f1",
  null
  
)

export default component.exports